import styled from "styled-components";
export const DivFlexColumn = styled.div`
  height: 100%;
  flex-direction: column;
  display: flex;
  justify-content: center;
`;

export const GradientDiv = styled.div`
background: rgba( 255, 255, 255, 0.55 );
box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 );
backdrop-filter: blur( 0.0px );
-webkit-backdrop-filter: blur( 0.0px );
border-radius: 10px;
border: 1px solid rgba( 255, 255, 255, 0.18 );
`